import { render, staticRenderFns } from "./ASC_ByDxPrintable.vue?vue&type=template&id=84098ace&scoped=true&"
import script from "./ASC_ByDxPrintable.vue?vue&type=script&lang=js&"
export * from "./ASC_ByDxPrintable.vue?vue&type=script&lang=js&"
import style0 from "./ASC_ByDxPrintable.vue?vue&type=style&index=0&id=84098ace&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84098ace",
  null
  
)

export default component.exports